import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import * as zIndexes from "zIndexes.module.scss";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    position: "absolute",
    background: theme.palette.white,
    zIndex: zIndexes.muiModalZIndex,
    left: theme.spacing(2),
    bottom: theme.spacing(2),
    width: "400px",
    height: "550px",
    borderRadius: "5px",
    padding: `${theme.spacing(1.25)} ${theme.spacing(2.5)} ${theme.spacing(
      2.25,
    )}`,
    boxShadow: "2px 4px 20px rgb(0 0 0 / 10%)",
  },
  contentMobile: {
    top: 0,
    right: "unset",
    bottom: "unset",
    width: "100vw",
    height: "100vh",
    padding: 0,
  },
  loadingContainer: {
    position: "relative",
    flexGrow: 1,
    width: "100%",
    borderRadius: 5,
    border: `1px solid ${theme.palette.gray.main}`,
  },
  loadingContainerMobile: {
    borderRadius: 0,
    border: "none",
  },
  loading: {
    position: "absolute",
    height: "100%",
    width: "100%",
  },
  iframe: {
    height: "100%",
    width: "100%",
    pointerEvents: "all",
  },
  header: {
    marginBottom: theme.spacing(1.5),
    width: "100%",
    cursor: "move",
  },
  headerMobile: {
    width: `calc(100vw - ${theme.spacing(4)})`,
    paddingTop: theme.spacing(2),
  },
  openInNewTabButton: {
    display: "flex",
    alignItems: "center",
  },
  openInNewTabButtonIcon: {
    fontSize: "16px",
    marginLeft: theme.spacing(0.5),
  },
}));

export default useStyles;
